import { defineNuxtPlugin } from '#app'
// import { baiduKey } from '~/utils/common'
// @ts-ignore
// import BaiduMap from 'vue-baidu-map-3x'

export default defineNuxtPlugin(_nuxtApp => {
  // 地图已改 iframe 嵌入，baiduKey 已停用
  // nuxtApp.vueApp.use(BaiduMap, { ak: baiduKey })
})
